var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tooltip',{staticClass:"w-full",attrs:{"label":_vm.condition.label,"type":"is-primary","append-to-body":""}},[_c('div',{staticClass:"connection-label truncate has-light-bg"},[_vm._v(" "+_vm._s(_vm.condition.label)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }